import { VIcon, VProgressLinear } from 'vuetify/lib'
import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import HintComponent from './HintComponent'
import {conctract_type, conctract_attribute, conctract_t_t, contract_i_e_types, contract_nature_list} from '../fields'
import { createContractParams, commonValidateRule, handleEditData } from '../utils'
import {contract_types_mixins} from './EditMixIns.jsx'
import styles from './index.module.less'
import {getContractDetailApi} from '../service'
import {mapGetters} from "vuex";
const commonValidateRuleGo = commonValidateRule('必选')


export default {
    mixins: [contract_types_mixins],
    data() {
        return {
            show: false,
            saving: false,
            params: createContractParams(),
            show_type: true,
            show_type_1: true,
            show_type_3: true,
            get_data_loading: false
        }
    },
    computed: {
        ...mapGetters('async', [ 'team_company_mapping_hash']),
        // 
        // 合同大类
        attrs_list() {
            const hash = this.contract_types_all_hash && this.contract_types_all_hash.income_expenses_hash || {}
            if (!this.params.contract_sz_type || !hash[this.params.contract_sz_type]) {
                return []
            }
            // 过滤
            const arr = []
            const has_hash = {}
            hash[this.params.contract_sz_type].forEach(item => {
                if (has_hash[item.main_type]) {
                    return 
                }
                has_hash[item.main_type] = true
                arr.push(item)
            });
            return arr
        },
        fields() {
            const _this = this
            return [
                {
                    label: '合同收支类型',
                    key:'contract_sz_type',
                    type: 'radio_buttons',
                    required: true,
                    rules:[commonValidateRuleGo],
                    cols: 4,
                    items: contract_i_e_types,
                    change(val) {
                       if (val === 'costless') {
                        _this.params.contract_nature = null
                       }
                       _this.params.contract_type_bread_id = null
                       _this.clearContractTypeId()
                    },
                    scopedSlots: {
                        label: () => {
                            return <div>
                                <span class={styles['mg-r']}><span style="color:red">*</span>合同收支类型</span>
                                <VIcon 
                                    size="20"
                                    color={_this.show_type ? 'primary' : ''}
                                    class={styles['cursor']}
                                    on={{
                                        click:() => {
                                            _this.show_type = !_this.show_type
                                        }
                                    }}
                                    >mdi-alert-circle-outline</VIcon>
                            </div>
                        }
                    }
                },
                {
                    key: 'hint',
                    cols: 8,
                },
                {
                    label: '合同属性',
                    key:'contract_nature',
                    type: 'radio_buttons',
                    cols: 4,
                    disabled: _this.params.contract_sz_type === 'costless',
                    required: true,
                    rules:[val => {
                        if (_this.params.contract_sz_type === 'costless') {
                            return true
                        }
                        return commonValidateRuleGo(val)
                    }],
                    items: contract_nature_list,
                    change:() => {
                      //  _this.clearContractTypeId()
                    },
                    scopedSlots: {
                        label: () => {
                            return <div>
                                <span class={styles['mg-r']}><span style="color:red">*</span>合同属性</span>
                                <VIcon 
                                    size="20"
                                    color={_this.show_type_1 ? 'primary' : ''}
                                    class={styles['cursor']}
                                    on={{
                                        click:() => {
                                            _this.show_type_1 = !_this.show_type_1
                                        }
                                    }}
                                    >mdi-alert-circle-outline</VIcon>
                            </div>
                        }
                    },
                    
                },
                {
                    key: 'hint_1',
                    cols: 8,
                },
                {
                    label: '合同类别',
                    key:'contract_type_bread_id',
                    type: 'autocompletes',
                    rules:[commonValidateRuleGo],
                    required: true,
                    cols: 4,
                    className: styles['m-t'],
                    items: this.attrs_list,
                    'item-value':'main_type',
                    'item-text':'mian_type_name',
                    change:() => {
           
                        _this.clearContractTypeId()
                    },
                    scopedSlots: {
                        label: () => {
                            return <div style="display:flex">
                                <span class={styles['mg-r']}><span style="color:red">*</span>合同类别</span>
                                <VIcon 
                                    size="20"
                                    color={_this.show_type ? 'primary' : ''}
                                    class={styles['cursor']}
                                    on={{
                                        click:() => {
                                            _this.show_type_3 = !_this.show_type_3
                                        }
                                    }}
                                    >mdi-alert-circle-outline</VIcon>
                            </div>
                        }
                    }
                },
                {
                    key: 'hint_2',
                    cols: 8,
                },
            ]
        },
        cur_customer() {
            return this.$store.state.cur_customer;
        },
    },
    created() {
        // 建立引用关系，从后端拉数据
        this.team_company_mapping_hash
    },
    methods: {
        // 合同小类清空
        clearContractTypeId() {
            this.params.contract_type_id = null
        },
        fromDraft(data) {
          const params = JSON.parse(JSON.stringify(data)) 
          this.params = params
          this.show = true
        },  
        getVirtualContractChildData(data) {
            return new Promise((response, reject) => {
             getContractDetailApi({id:data.id}).then(res => {
                 const params = handleEditData(res.contract)
                 response({params, contract:res.contract})
              }).catch(message => {
                 reject(message)
              })
            })
          },
          initParams() {
            this.params = createContractParams()
            // 制表人
            if (this.cur_customer.is_formal) {
                this.params.apply_user_id = this.cur_customer.id
                this.params.apply_user = this.cur_customer.account
                this.params.principal = this.cur_customer.account
            }
            this.params.fill_user = this.cur_customer.account
            // 申请人
            // this.params.apply_user_id = this.cur_customer.id
            // this.params.apply_user = this.cur_customer.account
            this.params.team_id = this.cur_customer.team_info.root_id
            // this.params.company_id = this.cur_customer.company_id
            const team_company_mapping_hash = this.team_company_mapping_hash
            const company = team_company_mapping_hash.companyTeamCorrespondGetCompant(this.params.team_id)
            this.params.company_id = company && company.company_id 
          },
        generateFromBlogRecords(data) {
            this.initParams()
            // this.params.ads_record_ids = data
            this.show = true
        },
        edit(data) {
            if (!data) {
                this.initParams()
            } else {
                this.get_data_loading = true
                getContractDetailApi({id:data.id}).then(res => {
                    this.params = handleEditData(res.contract)
                }).finally(() => {
                    this.get_data_loading = false
                })
                
            }
            this.show = true
        },
        submit() {
            if (this.$refs.base.validate()) {
                this.$emit('next', this.params)
                this.show = false
                this.$nextTick(() => {
                    this.params = createContractParams()    
                })
                
            }
        }
    },
    render() {
        const _this = this
        return <VModal
            dynamicHeight
            heightRate={0.8}
            v-model={_this.show}
            title={_this.params.id ? '编辑合同' : '创建合同'}
            loading={_this.saving}
            width={600}
            ref="modal"
            ok-text="下一步"
            on={{
                ok: () => {
                    this.submit() 
                },
                cancel:() => {
                    this.show = false
                    _this.params = createContractParams()
                }
            }}
        >
            {_this.get_data_loading && <VProgressLinear
                indeterminate
                color="primary"
                />}
            <VForm ref="base"
                v-model={_this.params}
                fields={_this.fields}
                scopedSlots={{
                    hint:() => {
                        return _this.show_type && <HintComponent
                        list={conctract_type}
                        on={{
                            close() {
                                _this.show_type = false
                            }
                        }}
                        /> || ''
                    },
                    hint_1:() => {
                        return _this.show_type_1 && <HintComponent
                        list={conctract_attribute}
                        on={{
                            close() {
                                _this.show_type_1 = false
                            }
                        }}
                        /> || ''
                    },
                    hint_2:() => {
                        return _this.show_type_3 && <HintComponent
                        list={conctract_t_t}
                        on={{
                            close() {
                                _this.show_type_3 = false
                            }
                        }}
                        /> || ''
                    },
                }}
                />
        </VModal>
    }
}